const i18n = (locale) => {
  return require(`./${locale}.json`);
};

export { i18n };
